/**
 * 编辑器场景的唯一标识——一个"场景"= 某个仓库下的某个父对象
 * （`parentId=null` 代表该仓库的根场景）。
 *
 * M3B 独立复审第二轮 NEW-2：`SceneSaveQueue`（待保存队列分桶）和
 * `save-reconcile.ts` 的粘性失败记录分桶，第一轮修复时都只按 `parentId`
 * 分桶——两个不同仓库的根场景 `parentId` 都是 `null`，会被当成同一个桶。
 * `LayoutEditorPage` 在仓库切换时并不重新挂载（路由没变，只是仓库选择器
 * 换了 `warehouseId`），场景重置 effect 之前也只依赖 `parentId`，因此仓库
 * 切换时既不会 flush 上一个仓库残留的待保存队列，也不会清掉上一个仓库的
 * sticky 失败记录/撤销历史。这里补上仓库这一维度，统一由这一个函数产出
 * 规范场景 key，`SceneSaveQueue`/`save-reconcile.ts`/页面的场景重置 effect
 * 都用它，不再各自维护一份编码（避免重蹈 M-4 的覆辙：两份独立实现迟早会
 * 互相脱节）。
 *
 * 用 `JSON.stringify` 编码二元组而不是手搓字符串拼接/前缀哨兵——两个字符串
 * （或 null）的 JSON 数组编码是单射的（标准转义规则保证不会有歧义），不需要
 * 再论证"这个分隔符不会被真实 id 包含"这种前提。
 */
export interface SceneRef {
  readonly warehouseId: string;
  readonly parentId: string | null;
}

export type SceneKey = string;

export function sceneKey(scene: SceneRef): SceneKey {
  return JSON.stringify([scene.warehouseId, scene.parentId]);
}
